import { FieldConfig } from 'model/deals.model';
import { DealTypeKeys } from './types';

export const coreDealInformation: FieldConfig[] = [
  {
    name: 'dealType',
    label: 'Deal Type',
    type: 'select',
    options: [],
    required: true,
  },
  {
    name: 'name',
    label: 'Deal Name',
    type: 'text',
    required: true,
  },
  {
    name: 'stageName',
    label: 'Deal Stage',
    type: 'select',
    options: [],
    required: true,
  },
  {
    name: 'client',
    label: 'Client',
    type: 'autocomplete',
    autocompleteType: 'client',
    required: true,
  },
  {
    name: 'business',
    label: 'Company Name',
    type: 'autocomplete',
    autocompleteType: 'company',
    required: true,
  },
  {
    name: 'owner',
    label: 'Owner',
    type: 'autocomplete',
    autocompleteType: 'owner',
    required: true,
  },
  {
    name: 'commission rate',
    label: 'Commission rate (%)',
    type: 'percentage',
  },
  {
    name: 'startDate',
    label: 'Start date',
    type: 'date',
    required: true,
  },
  {
    name: 'closeDate',
    label: 'End date',
    type: 'date',
    required: true,
  },
];

export const additionalInformationFields: FieldConfig[] = [
  {
    name: 'outcome',
    label: 'Outcome',
    type: 'select',
    options: [],
  },
  {
    name: 'lossReason',
    label: 'Loss reason',
    type: 'select',
    options: [],
  },
  {
    name: 'passReason',
    label: 'Pass reason',
    type: 'select',
    options: [],
  },
  { name: 'competitor', label: 'Competitor', type: 'text', sm: 6 },
];

export const projectInfoFields: FieldConfig[] = [
  { name: 'projectType', label: 'Project type', type: 'select', xs: 6, sm: 6 },
  {
    name: 'entertainmentCrossover',
    label: 'Entertainment crossover',
    type: 'select',
    xs: 6,
  },
  {
    name: 'careerStageCheck',
    label: 'Career Stage Check',
    type: 'select',
    xs: 6,
  },
  { name: 'lg3AMsInvolved', label: 'LG/3AMs involved', type: 'checkbox', xs: 6, sm: 6 },
  { name: 'clientRole', label: 'Client role', type: 'select', xs: 6, sm: 6 },
  {
    name: 'clientOwnership',
    label: 'Client ownership (%)',
    type: 'percentage',
    xs: 6,
  },
  { name: '3ASOwnership', label: '3AS ownership (%)', type: 'percentage', xs: 6, sm: 6 },
  { name: 'buyerPlatform', label: 'Buyer/Platform', type: 'text', xs: 6, sm: 6 },
];

export const financialFields: FieldConfig[] = [
  {
    name: 'dealStructure',
    label: 'Deal structure',
    type: 'select',
  },
  { name: 'equity', label: 'Equity/ownership (%)', type: 'percentage', sm: 6 },
  { name: 'backend', label: 'Backend', type: 'text', sm: 6 },
];

export const dualRevenueFields: FieldConfig[] = [
  {
    name: 'talentFeeCommissionRate',
    label: 'Talent fee commission rate (%)',
    type: 'percentage',
  },
  {
    name: 'talentFeeCommission',
    label: 'Talent fee commission',
    type: 'number',
  },
  {
    name: '3ASProductionFee',
    label: '3AS production fee ($)',
    type: 'amount',
  },
  {
    name: 'total3ASRevenue',
    label: 'Total 3AS revenue',
    type: 'amount',
  },
  { name: 'ownedRevenue', label: 'Owned revenue (%)', type: 'percentage', sm: 6 },
];

export const attributionTrackingFields: FieldConfig[] = [
  {
    name: 'leadershipSponsor',
    label: 'Leadership sponsor',
    type: 'text',
  },
  {
    name: 'source',
    label: 'Source',
    type: 'select',
  },

  { name: 'partnerAccount', label: 'Partner account', type: 'text', sm: 6 },
  { name: 'partnerContact', label: 'Partner contact', type: 'text', sm: 6 },
];

export const exclusivityFields: FieldConfig[] = [
  {
    name: 'exclusivityScope',
    label: 'Exclusivity',
    type: 'select',
    options: [],
  },
  {
    name: 'scope',
    label: 'Scope',
    type: 'select',
    options: [],
  },
  {
    name: 'language',
    label: 'Language',
    type: 'select',
    options: [],
  },
  {
    name: 'commitment',
    label: 'Commitment',
    type: 'select',
    options: [],
  },
  {
    name: 'rank',
    label: 'Rank',
    type: 'select',
    options: [],
  },
  {
    name: 'schedule',
    label: 'Schedule',
    type: 'select',
    options: [],
  },
];

export const BRANDDEAL: FieldConfig[] = [
  {
    name: 'probability',
    label: 'Probability',
    type: 'percentage',
    xs: 12,
    sm: 6,
  },
  {
    name: 'contractTerm',
    label: 'Contract term (month)',
    type: 'number',
    xs: 12,
    sm: 6,
  },

  {
    name: 'clientFitScore',
    label: 'Client fit score',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientApproval',
    label: 'Client approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'renewalProbability',
    label: 'Renewal probability (%)',
    type: 'percentage',
    xs: 12,
    sm: 6,
  },
  {
    name: 'revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'careerStage',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const CONTENT: FieldConfig[] = [
  {
    name: 'clientFitScore',
    label: 'Client fit score',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientApproval',
    label: 'Client approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'renewalProbability',
    label: 'Renewal probability (%)',
    type: 'percentage',
    xs: 12,
    sm: 6,
  },
  {
    name: 'revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'careerStage',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const SERVICE: FieldConfig[] = [
  {
    name: 'buyerType',
    label: 'Buyer type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'organizationName', label: 'Organization name', type: 'text', xs: 12, sm: 6 },
  {
    name: 'qualificationScore',
    label: 'Qualification score',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  { name: 'clientPlacement', label: 'Client placement', type: 'number', xs: 12, sm: 6 },
  { name: 'placedClients', label: 'Placed clients', type: 'text', xs: 12, sm: 6 },
  {
    name: 'engagementType',
    label: 'Engagement type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'developmentFee', label: 'Development fee', type: 'amount', xs: 12, sm: 6 },
  { name: 'retainerValue', label: 'Retainer value', type: 'amount', xs: 12, sm: 6 },
  { name: 'IPOwnership', label: 'IP Ownership (%)', type: 'percentage', xs: 12, sm: 6 },
  {
    name: 'lionsgateInvolved',
    label: 'Lionsgate involved',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'recruitingPipeline',
    label: 'Recruiting pipeline',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientFitScore',
    label: 'Client fit score',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientApproval',
    label: 'Client approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'renewalProbability',
    label: 'Renewal probability (%)',
    type: 'percentage',
    xs: 12,
    sm: 6,
  },
  {
    name: 'revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const INVESTMENT: FieldConfig[] = [
  {
    name: 'investmentType',
    label: 'Investment type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'entityName', label: 'Entity name', type: 'text', xs: 12, sm: 6 },
  {
    name: 'industrySector',
    label: 'Industry sector',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'investmentAmount',
    label: 'Investment amount',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'ownershipTarget',
    label: 'Ownership target (%)',
    type: 'percentage',
    xs: 12,
    sm: 6,
  },
  {
    name: 'preMoneyValuation',
    label: 'Pre-money valuation',
    type: 'amount',
    xs: 12,
    sm: 6,
  },
  {
    name: 'boardSeat',
    label: 'Board seat',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'targetExitMultiple',
    label: 'Target exit multiple',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientFitScore',
    label: 'Client fit score',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientApproval',
    label: 'Client approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'renewalProbability',
    label: 'Renewal probability (%)',
    type: 'percentage',
    xs: 12,
    sm: 6,
  },
  {
    name: 'revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const APPEARANCE: FieldConfig[] = [
  {
    name: 'eventType',
    label: 'Event type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'eventName', label: 'Event name', type: 'text', xs: 12, sm: 6 },
  { name: 'eventDate', label: 'Event date', type: 'date', xs: 12, sm: 6 },
  { name: 'eventLocation', label: 'Event location', type: 'text', xs: 12, sm: 6 },
  { name: 'duration', label: 'Duration (hours)', type: 'number', xs: 12, sm: 6 },
  {
    name: 'travelRequired',
    label: 'Travel required',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'contentRights',
    label: 'Content rights',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'paymentTerms',
    label: 'Payment terms',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const OWNEDEVENT: FieldConfig[] = [
  {
    name: 'eventPropertyName',
    label: 'Event property name',
    type: 'text',
    xs: 12,
    sm: 6,
  },
  {
    name: 'ownershipStructure',
    label: 'Ownership structure',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  { name: '3ASOwnership', label: '3AS Ownership (%)', type: 'percentage', xs: 12, sm: 6 },
  {
    name: 'expectedAttendance',
    label: 'Expected attendance',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'ticketRevenueTarget',
    label: 'Ticket revenue target ($)',
    type: 'amount',
    xs: 12,
    sm: 6,
  },
  {
    name: 'sponsorshipRevenueTarget',
    label: 'Sponsorship revenue target ($)',
    type: 'amount',
    xs: 12,
    sm: 6,
  },

  {
    name: 'productionBudget',
    label: 'Production budget ($)',
    type: 'amount',
    xs: 12,
    sm: 6,
  },
  {
    name: 'projectedMargin',
    label: 'Projected margin (%)',
    type: 'percentage',
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientFitScore',
    label: 'Client fit score',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientApproval',
    label: 'Client approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'renewalProbability',
    label: 'Renewal probability (%)',
    type: 'percentage',
    xs: 12,
    sm: 6,
  },
  {
    name: 'revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const LICENSING: FieldConfig[] = [
  {
    name: 'licenseType',
    label: 'License type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'AIRightsFlag',
    label: 'AI rights flag',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'guaranteedMinimum',
    label: 'Guaranteed minimum ($)',
    type: 'amount',
    xs: 12,
    sm: 6,
  },
  { name: 'royaltyRate', label: 'Royalty rate (%)', type: 'percentage', xs: 12, sm: 6 },
  { name: 'territory', label: 'Territory', type: 'select', options: [], xs: 12, sm: 6 },
  {
    name: 'productApproval',
    label: 'Product approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'reportingFrequency',
    label: 'Reporting frequency',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientFitScore',
    label: 'Client fit score',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'clientApproval',
    label: 'Client approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'renewalProbability',
    label: 'Renewal probability (%)',
    type: 'percentage',
    xs: 12,
    sm: 6,
  },
  {
    name: 'revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const DYNAMIC_DATA_MAP: Record<DealTypeKeys, FieldConfig[]> = {
  BRANDDEAL,
  '3ASSERVICE': SERVICE,
  INVESTMENT,
  APPEARANCE,
  OWNEDEVENT,
  LICENSING,
  CONTENT,
};
